import * as React from 'react';

import { trackLeaveFeedbackClick } from '../../tracking';
import * as styles from './styles/styles.css';

interface ITextWithLinkProps {
  onClick(): void;
  isLeadFactory: boolean;
  showWarningMessage: boolean;
}

export function TextWithLink({ onClick, isLeadFactory, showWarningMessage }: ITextWithLinkProps) {
  const handleClick = () => {
    trackLeaveFeedbackClick();

    onClick();
  };

  const renderWarningMessage = () =>
    showWarningMessage ? (
      <p className={styles['description']}>Не вносите предоплату до просмотра объекта и заключения договора!</p>
    ) : null;

  if (isLeadFactory) {
    return (
      <>
        {renderWarningMessage()}
        <p className={styles['description']}>
          Пожалуйста,{' '}
          <a href="#" onClick={handleClick}>
            оставьте отзыв
          </a>{' '}
          после звонка
        </p>
      </>
    );
  }

  return (
    <>
      {renderWarningMessage()}
      <p className={styles['description']}>
        Пожалуйста, скажите, что нашли это объявление на ЦИАН. И{' '}
        <a href="#" onClick={handleClick}>
          оставьте отзыв
        </a>{' '}
        после звонка
      </p>
    </>
  );
}
